var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.744078 0.577574C1.06951 0.252137 1.59715 0.252137 1.92259 0.577574L7.72523 6.38022C7.88151 6.5365 7.96931 6.74846 7.96931 6.96947C7.96931 7.19049 7.88151 7.40245 7.72523 7.55873L1.92259 13.3614C1.59715 13.6868 1.06951 13.6868 0.744078 13.3614C0.418641 13.0359 0.418641 12.5083 0.744078 12.1829L5.95747 6.96947L0.744078 1.75609C0.418641 1.43065 0.418641 0.903011 0.744078 0.577574Z",
    fill: "#F7F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardW);
export default __webpack_public_path__ + "static/media/ForwardW.84e549111582e98d91d831fc6b697230.svg";
export { ForwardRef as ReactComponent };